import HttpRequest from './HttpRequest';

export default class AdomiComponentService extends HttpRequest {
  static endpoint = 'adomi-components';

  static async getAll() {
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    const response = await this.get(id);
    return response;
  }

  static async search(string) {
    this.endpoint = `adomi-components?name=${string}`;
    const response = await this.get();
    return response;
  }

  static async create(data) {
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    const response = await this.put(id, data);
    return response;
  }
}
